import { render, staticRenderFns } from "./radio-test.vue?vue&type=template&id=7bc73404&lang=html"
import script from "./radio-test.vue?vue&type=script&lang=js"
export * from "./radio-test.vue?vue&type=script&lang=js"
import style0 from "./radio-test.vue?vue&type=style&index=0&id=7bc73404&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports